import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

// api requests
import {
  createVehicleTypeApi,
  editVehicleTypeDataByIdApi,
  getVehicleTypeDataByIdApi,
  getVehicleTypeListApi,
} from "../../requests/master/vehicleTypeRequests";

// redux action types
import { VehicleTypeActionTypes, VehicleTypeActions } from "../../../actionTypes/master/vehicleTypeActionTypes";

// redux actions
import {
  getVehicleTypeList,
  setVehicleTypeDataById,
  setVehicleTypeList,
  setVehicleTypeListPageCount,
} from "../../../actions/master/vehicleTypeAction";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createVehicleTypeHandler(action: VehicleTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createVehicleTypeApi, action.payload);
    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVehicleTypeListHandler(action: VehicleTypeActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVehicleTypeListApi, action.payload);
    if (data.status) {
      yield put(setVehicleTypeList(data?.data?.rows));
      yield put(setVehicleTypeListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVehicleTypeDataByIdHandler(action: VehicleTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVehicleTypeDataByIdApi, action.payload);
    if (data.status) {
      yield put(setVehicleTypeDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editVehicleTypeDataByIdHandler(action: VehicleTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editVehicleTypeDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getVehicleTypeList({ page: 0, pageLimit: 10 })); // refetching the data after updating
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// vehicleType sagas
export default function* vehicleTypeSaga() {
  yield takeLatest(VehicleTypeActions.CREATE_VEHICLE_TYPE, createVehicleTypeHandler);
  yield takeLatest(VehicleTypeActions.GET_VEHICLE_TYPE_LIST, getVehicleTypeListHandler);
  yield takeLatest(VehicleTypeActions.GET_VEHICLE_TYPE_DATA_BY_ID, getVehicleTypeDataByIdHandler);
  yield takeLatest(VehicleTypeActions.EDIT_VEHICLE_TYPE_DATA_BY_ID, editVehicleTypeDataByIdHandler);
}
